import { RequeteurDomaineEnum } from "../../dto/GenApi.iNotPaie.Dto/RequeteurDomaineEnum";
import { RequeteurPropEnum } from "../../dto/GenApi.iNotPaie.Dto/RequeteurPropEnum";

export const champsRequeteur = [
	// ------------------------------------------------- SALARIE
	{
		Domaine: RequeteurDomaineEnum.Salarie,
		Prop: RequeteurPropEnum.Adresse,
		Name: "Adresse",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Salarie,
		Prop: RequeteurPropEnum.DateNaissance,
		Name: "Date de naissance",
		FuncName: undefined,
		Check: false,
		Filter: { Type: "Date" }
	},
	{
		Domaine: RequeteurDomaineEnum.Salarie,
		Prop: RequeteurPropEnum.DateEntree,
		Name: "Entrée dans l'étude",
		FuncName: "FuncCalcAnneesEtudes",
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Salarie,
		Prop: RequeteurPropEnum.CleSecu,
		Name: "Clé de sécurité sociale",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Salarie,
		Prop: RequeteurPropEnum.Crpcen,
		Name: "CRPCEN",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Salarie,
		Prop: RequeteurPropEnum.CodeNationalite,
		Name: "Code nationalite",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Salarie,
		Prop: RequeteurPropEnum.CommuneCodePostal,
		Name: "Code Postal",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Salarie,
		Prop: RequeteurPropEnum.CommuneLibelle,
		Name: "Commune",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Salarie,
		Prop: RequeteurPropEnum.MailPerso,
		Name: "Email perso.",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Salarie,
		Prop: RequeteurPropEnum.EmailProfessionnel,
		Name: "Email pro.",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Salarie,
		Prop: RequeteurPropEnum.Nom,
		Name: "Nom",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Salarie,
		Prop: RequeteurPropEnum.NomNaissance,
		Name: "Nom de naissance",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Salarie,
		Prop: RequeteurPropEnum.PersonneAPrevenirNom,
		Name: "Nom personne à prévenir",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Salarie,
		Prop: RequeteurPropEnum.NumSecu,
		Name: "Numéro sécurité sociale",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Salarie,
		Prop: RequeteurPropEnum.Prenom,
		Name: "Prénom",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Salarie,
		Prop: RequeteurPropEnum.CodeSexe,
		Name: "Sexe",
		FuncName: undefined,
		Check: false,
		Filter: {
			Type: "Selection",
			Values: [
				{
					Code: "\"1\"",
					Name: "Homme"
				},
				{
					Code: "\"2\"",
					Name: "Femme"
				}
			]
		}
	},
	{
		Domaine: RequeteurDomaineEnum.Salarie,
		Prop: RequeteurPropEnum.TelFixe,
		Name: "Tél. fixe",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Salarie,
		Prop: RequeteurPropEnum.PersonneAPrevenirTel,
		Name: "Tél. personne à prévenir",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Salarie,
		Prop: RequeteurPropEnum.TelPortable,
		Name: "Tél. portable",
		FuncName: undefined,
		Check: false
	},
	// ------------------------------------------------- CONTRAT
	{
		Domaine: RequeteurDomaineEnum.Contrat,
		Prop: RequeteurPropEnum.CodeQualification,
		Name: "Nombre de points",
		FuncName: "FuncGetNombreDePoints",
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Contrat,
		Prop: RequeteurPropEnum.DateEntree,
		Name: "Date d'entrée",
		FuncName: undefined,
		Check: false,
		Filter: { Type: "Date" }
	},
	{
		Domaine: RequeteurDomaineEnum.Contrat,
		Prop: RequeteurPropEnum.CodeCaisseComplementaire,
		Name: "Caisse complementaire",
		FuncName: "FuncGetCaisseComplementaireLibelle",
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Contrat,
		Prop: RequeteurPropEnum.CodeAutreCaisse,
		Name: "Autre caisse complementaire",
		FuncName: "FuncGetCaisseComplementaireLibelle",
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Contrat,
		Prop: RequeteurPropEnum.CodeClassification,
		Name: "Code classification",
		FuncName: undefined,
		Check: false,
		Filter: {
			Type: "Drop",
			Values: "CLASI"
		}
	},
	{
		Domaine: RequeteurDomaineEnum.Contrat,
		Prop: RequeteurPropEnum.CodeConventionCollective,
		Name: "Convention collective",
		FuncName: "FuncGetConventionCollectiveLibelle",
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Contrat,
		Prop: RequeteurPropEnum.CodeCodeInsee,
		Name: "INSEE",
		FuncName: "FuncGetCodeInseeLibelle",
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Contrat,
		Prop: RequeteurPropEnum.DateDebutContrat,
		Name: "Date début contrat",
		FuncName: undefined,
		Check: false,
		Filter: { Type: "Date" }
	},
	{
		Domaine: RequeteurDomaineEnum.Contrat,
		Prop: RequeteurPropEnum.DateFinContrat,
		Name: "Date fin contrat",
		FuncName: undefined,
		Check: false,
		Filter: { Type: "Date" }
	},
	{
		Domaine: RequeteurDomaineEnum.Contrat,
		Prop: RequeteurPropEnum.DateDebutTransfert,
		Name: "Date transfert du contrat",
		FuncName: undefined,
		Check: false,
		Filter: { Type: "Date" }
	},
	{
		Domaine: RequeteurDomaineEnum.Contrat,
		Prop: RequeteurPropEnum.CodeDureeContrat,
		Name: "Durée contrat",
		FuncName: "FuncGetDureeContratLibelle",
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Contrat,
		Prop: RequeteurPropEnum.CodeGestionConge,
		Name: "Gestion congés",
		FuncName: "FuncGetGestionCongesLibelle",
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Contrat,
		Prop: RequeteurPropEnum.LibelleEmploi,
		Name: "Libellé emploi",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Contrat,
		Prop: RequeteurPropEnum.CodeMaladieRetraite,
		Name: "Maladie / Retraite",
		FuncName: "FuncGetMaladieRetraiteLibelle",
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Contrat,
		Prop: RequeteurPropEnum.CodeMotifRuptureContrat,
		Name: "Motif rupture contrat",
		FuncName: "FuncGetMotifRuptureContratLibelle",
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Contrat,
		Prop: RequeteurPropEnum.CodeNatureContrat,
		Name: "Nature du contrat",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Contrat,
		Prop: RequeteurPropEnum.NumeroContrat,
		Name: "Numéro contrat",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Contrat,
		Prop: RequeteurPropEnum.NotaireResponsable,
		Name: "Notaire responsable",
		FuncName: "FuncGetNotaireResponsableNomComplet",
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Contrat,
		Prop: RequeteurPropEnum.Qualification,
		Name: "Qualification",
		FuncName: "FuncGetQualificationLibelle",
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Contrat,
		Prop: RequeteurPropEnum.IdResponsableHierarchique,
		Name: "Responsable hiérarchique",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Contrat,
		Prop: RequeteurPropEnum.CodeRemuneration,
		Name: "Rémunération",
		FuncName: "FuncGetRemunerationLibelle",
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Contrat,
		Prop: RequeteurPropEnum.CodeService,
		Name: "Service",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Contrat,
		Prop: RequeteurPropEnum.CodeTypeContrat,
		Name: "Type contrat",
		FuncName: "FuncGetTypeContratLibelle",
		Check: false
	},
	// ------------------------------------------------- ABSENCE
	{
		Domaine: RequeteurDomaineEnum.Absence,
		Prop: RequeteurPropEnum.NombreJours,
		Name: "Nombres de jours",
		FuncName: undefined,
		Check: false
	},
	// ------------------------------------------------- BULLETIN
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.NumeroBulletin,
		Name: "Numéro bulletin",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.NumeroSalarie,
		Name: "Numéro salarie",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.CodeSociete,
		Name: "Code de la sociéte",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.Mois,
		Name: "Mois",
		FuncName: undefined,
		Check: false,
		Filter: {
			Type: "Drop",
			Values: "MONTH"
		}
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.Annee,
		Name: "Année",
		FuncName: undefined,
		Check: false,
		Filter: { Type: "Number" }
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.Montant,
		Name: "Montant",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.DateDebut,
		Name: "Date de début",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.DateFin,
		Name: "Date de fin",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.DateVirement,
		Name: "Date de virement",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.HeuresBulletin,
		Name: "Heures",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.CoefficiantBulletin,
		Name: "Coefficient",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.CongesAcquis,
		Name: "Congés acquis",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.CongesPris,
		Name: "Congés pris",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.CongesPrisMois,
		Name: "Congés pris par mois",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.ProrataPresence,
		Name: "Prorata présence",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.SalaireBrutApresIJ,
		Name: "Salaire brut après IJ",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.SalaireBrutAvantIJ,
		Name: "Salaire brut avant IJ",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.ChargesSalariales,
		Name: "Charges salariales",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.NetImposable,
		Name: "Net imposable",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.NetAPayer,
		Name: "Net à payer",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.CotisationsPatronales,
		Name: "Cotisations patronales",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.IJMaladieBrut,
		Name: "IJ maladie brut",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.IJMaterniteBrut,
		Name: "IJ maternité brut",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.IJAccidentTravailBrut,
		Name: "IJ Accident de travail brut",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.SalaireBase,
		Name: "Salaire de base",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.CodeDepart,
		Name: "Code de départ",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.NetDu,
		Name: "Net dû",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.CodeRegime,
		Name: "Code de régime",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.CTVABU,
		Name: "CTVABU",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.CongesDroitOuvert,
		Name: "Congés droit ouvert",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.RttAcquis,
		Name: "Rtt acquis",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.RttPris,
		Name: "Rtt pris",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.RttPrisMois,
		Name: "Rtt pris mois",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Bulletin,
		Prop: RequeteurPropEnum.RttDroitOuvert,
		Name: "Rtt droit ouvert",
		FuncName: undefined,
		Check: false
	},
	// ------------------------------------------------- REGLEMENT
	{
		Domaine: RequeteurDomaineEnum.Reglement,
		Prop: RequeteurPropEnum.Nature,
		Name: "Nature mode règlement",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Reglement,
		Prop: RequeteurPropEnum.Mode,
		Name: "Mode de règlement",
		FuncName: "FuncGetModeReglementLibelle",
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Reglement,
		Prop: RequeteurPropEnum.IbanCP,
		Name: "IbanCP",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Reglement,
		Prop: RequeteurPropEnum.IbanCC,
		Name: "IbanCC",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Reglement,
		Prop: RequeteurPropEnum.Bban,
		Name: "Bban",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Reglement,
		Prop: RequeteurPropEnum.Bic,
		Name: "Bic",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Reglement,
		Prop: RequeteurPropEnum.Titulaire,
		Name: "Titulaire du compte",
		FuncName: undefined,
		Check: false
	},
	{
		Domaine: RequeteurDomaineEnum.Reglement,
		Prop: RequeteurPropEnum.Domiciliation,
		Name: "Domiciliation",
		FuncName: undefined,
		Check: false
	}
];



// WEBPACK FOOTER //
// ./src/components/requeteurModifieur/requeteurListeChamps.ts